export const ADD_CUSTOM_APP_INSTANCE = 'spaces/appinstance/custom/ADD'
export const ADD_CUSTOM_APP_INSTANCE_SUCCESS = `${ADD_CUSTOM_APP_INSTANCE}_SUCCESS`

export const FETCH_CUSTOM_APP_INSTANCE = 'space/app/custom/FETCH'
export const FETCH_CUSTOM_APP_INSTANCE_SUCCESS = `${FETCH_CUSTOM_APP_INSTANCE}_SUCCESS`

export const UPDATE_CUSTOM_APP_INSTANCE = 'space/app/custom/UPDATE'
export const UPDATE_CUSTOM_APP_INSTANCE_SUCCESS = `${UPDATE_CUSTOM_APP_INSTANCE}_SUCCESS`

export const DELETE_CUSTOM_APP_INSTANCE = 'space/app/custom/DELETE'
export const DELETE_CUSTOM_APP_INSTANCE_SUCCESS = `${DELETE_CUSTOM_APP_INSTANCE}_SUCCESS`

export const CLEAR_CURRENT_APP = 'space/app/custom/FETCH'
export const SET_CURRENT_APP = 'space/app/custom/SET'
export const SET_CURRENT_CONNECTOR = 'SET_CURRENT_CONNECTOR'
export const SET_CURRENT_MICROAPPS = 'SET_CURRENT_MICROAPPS'
